// src/hooks/useArticles.ts

import { useState, useEffect } from "react";
import getGraphData from "../apis/contentApis/getGraphData";
import { openNotification } from "../utils/UI/openNotification";

const useGraphHook = (digitalFilter: any) => {
  const [graphdata, setGraphdata] = useState([]);
  const [articals, setArticals] = useState([]);
  const [totalInvestment, setTotalInvestment] = useState(0);
  const [digitalPublicationsdata, setDigitalPublicationsdata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cartdata, setcartdata] = useState([]);
  const fetchArticles = async () => {
    try {
      setLoading(true);
      const response = await getGraphData(digitalFilter);
      if (!response?.response?.status) throw response;
      setArticals(response.response?.articals);
      setDigitalPublicationsdata(response.response?.tableData);
      setcartdata(response.response?.digitalData1);
      setGraphdata(response.response?.data);
      setTotalInvestment(response.response?.totalInvestment);
    } catch (err: any) {
      console.error(err);
      // openNotification("error", {
      //   message: err?.message || "Failed to fetch articles!",
      // });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!digitalFilter) return;
    fetchArticles();
  }, [digitalFilter]);

  return {
    graphdata,
    articals,
    cartdata,
    digitalPublicationsdata,
    loading,
    totalInvestment,
  };
};

export default useGraphHook;
